import { useTranslation } from 'react-i18next';
import Header from '../components/feature/Header';
import Footer from '../components/feature/Footer';

export default function BlogTrailerPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 bg-bg">
        <div className="mx-auto max-w-3xl px-5 py-14">
          <span className="inline-flex rounded-full bg-primary-soft px-3 py-1 text-[12px] font-medium text-primary">{t('blog.post2.category')}</span>
          <h1 className="mt-3 text-[26px] font-bold tracking-tight">{t('blog.post2.title')}</h1>
          <p className="mt-2 text-[14px] text-muted">{t('blog.post2.readTime')}</p>
          <div className="mt-8 space-y-4 text-[15px] leading-relaxed text-ink-soft">
            <p>{t('blog.post2.body.p1')}</p>
            <p>{t('blog.post2.body.p2')}</p>
            <p>{t('blog.post2.body.p3')}</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
